export default "/images/6cfd2837142c55be2d86ef31ef675508.avif";